<div class="content-card">
  <h2 class="content-card__header">{{ 'WF-PersonalData' | translate }}</h2>
  <table>
    <tbody>
      <tr class="key-value-row">
        <td class="key-value-row__key">
          {{ 'FullName' | translate }}
        </td>
        <td class="key-value-row__value">
          <a class="dark-anchor" [routerLink]="['/profile', agreement.WorkerId]" download>{{ agreement.FullName }}</a>
        </td>
      </tr>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'DateOfBirth' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.DateOfBirth | date: 'yyyy-MM-dd' }}</td>
      </tr>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'Pesel' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.Pesel }}</td>
      </tr>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'IdentityDocument' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.Document }}</td>
      </tr>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'NationalHealthFund' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.NationalHealthFund }}</td>
      </tr>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'TaxOffice' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.TaxOffice }}</td>
      </tr>
      @if (showBankAccountNumber$ | async) {
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'BankAccountNumber' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.BankAccountNumber | bankAccountFormat }}</td>
      </tr>
      }
    </tbody>
  </table>
</div>
<div class="content-card">
  <h2 class="content-card__header">{{ 'WAD-EmployerDetails' | translate }}</h2>
  <table>
    <tbody>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'WAD-EmployerName' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.EmployerName }}</td>
      </tr>
      @if (agreement.Location) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'Location' | translate }}</td>
          <td class="key-value-row__value">{{ agreement.Location }}</td>
        </tr>
      }
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'EmployerObject' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.EmployerObject }}</td>
      </tr>
      @if (agreement.OrderItemName && hasAssignOrderItemPermission) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WAD-OrderItem' | translate }}</td>
          <td class="key-value-row__value">{{ agreement.OrderItemName }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>
<div class="content-card">
  <h2 class="content-card__header">{{ 'WAD-AgreementDetails' | translate }}</h2>
  <table>
    <tbody>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'Company' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.CompanyName }}</td>
      </tr>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'EmploymentType' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.EmploymentType }}</td>
      </tr>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'AgreementType' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.AgreementType }}</td>
      </tr>
      @if (agreement.WorkPattern && agreement.WorkPatternId !== workPatternEnum.NoApplicable) {
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WorkPattern' | translate }}</td>
          <td class="key-value-row__value">{{ agreement.WorkPattern }}</td>
        </tr>
      }
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'AgreementConclusionDate' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.ConclusionDate | date: 'yyyy-MM-dd' }}</td>
      </tr>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'EmploymentDateFrom' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.EmploymentDateFrom | date: 'yyyy-MM-dd' }}</td>
      </tr>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'EmploymentDateTo' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.EmploymentDateTo | date: 'yyyy-MM-dd' }}</td>
      </tr>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'NoticePeriod' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.NoticePeriod }}</td>
      </tr>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'PaymentDeadline' | translate }}</td>
        <td class="key-value-row__value">{{ agreement.PaymentDeadline }}</td>
      </tr>
      <tr class="key-value-row">
        <td class="key-value-row__key">{{ 'JobResponsibilities' | translate }}</td>
        <td class="key-value-row__value">
          @for (responsibility of agreement.Responsibilities; track responsibility) {
            <div>
              {{ responsibility }}
            </div>
          }
        </td>
      </tr>
    </tbody>
    @if (agreement.JobTitle) {
      <tbody
        appPropertyWithHistory
        [label]="'JobTitle' | translate"
        [currentValue]="agreement.JobTitle"
        [history]="jobTitleHistory"
        [showHistory]="showHistory"
        (annexClick)="navigateToAnnex($event)"
      ></tbody>
    }

    <tbody
      appWagesWithHistory
      [label]="'Wages' | translate"
      [currentValue]="agreement.Wages"
      [history]="wagesHistory"
      [showHistory]="showHistory"
      (annexClick)="navigateToAnnex($event)"
    ></tbody>
    @if (agreement.AgreementTemplate) {
      <tbody>
        <tr class="key-value-row">
          <td class="key-value-row__key">{{ 'WAD-AgreementTemplate' | translate }}</td>
          <td class="key-value-row__value">{{ agreement.AgreementTemplate }}</td>
        </tr>
      </tbody>
    }
  </table>
</div>
